module.exports = __webpack_public_path__ + "static/media/ok-btn.3b52a3ff.svg";